import type { IntlFormatters } from "react-intl";
import { createIntlConfigurationStore } from "../../utils/createIntlConfigurationStore";
import type { CopyKeyCare, CopyKeyPortal, CopyKeyWebshop, FormatMessageArgs, FormatTimeOptions } from "./types";

// Avoid importing presentation here to prevent circular deps; define stable, app-specific shapes
type IntlBaseShape<Id extends string> = {
  formatMessage: (
    descriptor: FormatMessageArgs[0] & { id?: Id },
    values?: FormatMessageArgs[1],
    options?: FormatMessageArgs[2],
  ) => string;
  formatTime: (options: FormatTimeOptions & { hideSeconds?: boolean; hideColumn?: boolean }) => string;
  formatDate: IntlFormatters["formatDate"];
  formatNumber: IntlFormatters["formatNumber"];
  formatPercentage: (value: number) => string;
  formatRelativeTime: IntlFormatters["formatRelativeTime"];
  formatTimeWithUnits: (options: FormatTimeOptions & { hideSeconds?: boolean; hideColumn?: boolean }) => string;
};

export type IntlShapeCare = IntlBaseShape<CopyKeyCare>;
export type IntlShapePortal = IntlBaseShape<CopyKeyPortal>;
export type IntlShapeWebshop = IntlBaseShape<CopyKeyWebshop>;

export const useIntlConfigurationStoreCare = createIntlConfigurationStore<IntlShapeCare>();
export const useIntlConfigurationStorePortal = createIntlConfigurationStore<IntlShapePortal>();
export const useIntlConfigurationStoreWebshop = createIntlConfigurationStore<IntlShapeWebshop>();

export const DEFAULT_INTL_ACTIONS = {
  formatMessage: () => "",
  formatTime: () => "",
  formatDate: () => "",
  formatNumber: () => "",
  formatPercentage: () => "",
  formatRelativeTime: () => "",
  formatTimeWithUnits: () => "",
};
